import './footer.scss';

import React from 'react';
import { Col, Row } from 'reactstrap';

const Footer = () => (
  <footer className="footer">
    <div className="footer-container">
      <Row className="align-items-center">
        {/* Logo */}
        <Col md="3" className="footer-logo">
          <img src="content/images/footer-logo.png" alt="Startups Reactor" />
        </Col>

        {/* Company Info */}

        <Col md="4" className="footer-info">
          <Row>
            <Col>
              <h5>Startups Reactor LTD</h5>
            </Col>
            <Col>
              <p>+44 7776 666 071</p>
              <p>yilmaz@startupsreactor.com</p>
            </Col>
          </Row>
        </Col>

        {/* Social Icons */}
        <Col md="4" className="footer-social">
          <a href="#" aria-label="LinkedIn">
            <img src="content/images/icons/icon_linkedin.png" alt="" />
          </a>
          <a href="#" aria-label="Facebook">
            <img src="content/images/icons/icon_facebook.png" alt="" />
          </a>
          <a href="#" aria-label="Instagram">
            <img src="content/images/icons/icon_instagram.png" alt="" />
          </a>
          <a href="#" aria-label="Twitter">
            <img src="content/images/icons/icon_twitter.png" alt="" />
          </a>
          <a href="#" aria-label="WhatsApp">
            <img src="content/images/icons/icon_whatsapp.png" alt="" />
          </a>
        </Col>
      </Row>

      {/* Bottom */}
      <div className="footer-bottom">© {new Date().getFullYear()} Startups Reactor. All rights reserved.</div>
    </div>
  </footer>
);

export default Footer;
